const API_BASE_URL = process.env.VUE_APP_API_URL;
const ENABLE_MBILE_SITE = process.env.VUE_APP_ENABLE_MBILE_SITE;

export default {
  API_BASE_URL: API_BASE_URL,
  ENABLE_MBILE_SITE: ENABLE_MBILE_SITE,
};
